import moment from "moment";
import "@/styles/sass/main.scss";

export default {
  install(vue) {
    vue.prototype.$moment = moment;
  },
};
